import { IController, IScope, IWindowService } from 'angular';
import { IStateService } from 'angular-ui-router';

export class SupportDuplicationCtrl implements IController {
  static $inject = ['$scope', '$state', '$window'];

  // Bindings
  public supportId: string;
  public browserTab: string;

  constructor(private $scope: IScope, private $state: IStateService, private $window: IWindowService) {}

  $onInit() {
    //
  }

  public duplicateSupport(tab) {
    // TODO - refactor stateParam naming. Is confusing. - JYR
    const state = 'main.school.settings.supports.duplicate';
    const params = {
      supportToDuplicateId: this.supportId,
    };

    if (tab === 'new') {
      let url = this.$state.href(state, params);
      this.$window.open(url, '_blank');
    } else if (tab === 'current') this.$state.go(state, params);
  }
}
